"use client";

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import Smartlook from "smartlook-client";

const isSmartlookEnabled = Boolean(process.env.NEXT_PUBLIC_SMARTLOOK_KEY);

function runWhenReady(action: () => void) {
	if (!isSmartlookEnabled || typeof window === "undefined") {
		return;
	}

	if (!Smartlook.initialized()) {
		return;
	}

	try {
		action();
	} catch {
		// Smartlook throws WebSDKError when anonymize runs without an active session.
	}
}

export const smartlook = {
	anonymize: () => {
		runWhenReady(() => {
			Smartlook.anonymize();
		});
	},

	identify: (
		userId: string | number,
		props: Record<string, string | number | boolean>,
	) => {
		runWhenReady(() => {
			Smartlook.identify(userId, props);
		});
	},
};
